//Angular Modules
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
//Shared Services
import { CustomMessageService } from '@app/shared/components/custom-message/custom-message.service';
import { LoggerService } from '@app/logger/logger.service';
import { ContractsService } from '@app/shared/services/entities/contracts.service';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@app/material.module';
const log = new LoggerService('CONTRACT DIALOG COMPONENT');

@Component({
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
],
  selector: 'app-contracts-dialog',
  templateUrl: './contracts-dialog.component.html',
  styleUrls: ['./contracts-dialog.component.scss']
})
export class ContractsDialogComponent implements OnInit {

  public contractForm: FormGroup;
  public inputs = [];
  public record = null;
  public tableName = 'contracts';

  constructor(
    private formBuilder: FormBuilder,
    private contractsService: ContractsService,
    public dialogRef: MatDialogRef<ContractsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private customMessageService: CustomMessageService
  ) { }

  ngOnInit(): void {
    //log.debug(this.data);
    this.inputs = this.data.inputs;
    this.record = this.data.record;
    let group = {};
    for (const input of this.inputs) {
      group[input['name']] = [this.data.type == 'update' ? this.record[input['name']] : null, input['required'] ? Validators.required : null];
    }
    this.contractForm = this.formBuilder.group(group)
  }


  /**@description Crea nuevo objeto de la entidad */
  async createEntityData(){
    let data = this.contractForm.value;
    try{
      this.customMessageService.open({title: 'Espere', type: 'success', message: 'Guardando información...', loading: true });
      data['operationType'] = 'single'
      let apiResponse = await this.contractsService.create(data);
      //log.debug(apiResponse)
      this.customMessageService.close()
      if (apiResponse['state'] == 'success') {
        await this.customMessageService.open({title: '¡Hecho!', type: apiResponse['state'], message: apiResponse['message'], duration: 2000 });
        let row = apiResponse['data'][0];
        this.dialogRef.close(row);
      }else{
        await this.customMessageService.open({title: 'Error', type: apiResponse['state'], message: apiResponse['message'], dismissBtn: true });
      }
    }catch(err){
      this.customMessageService.close();
      await this.customMessageService.open({title: 'Error', type: 'error', message: err, dismissBtn: true });
    }
  }

  /**@description Actualiza objeto de la entidad */
  async updateEntityData(){
    let data = this.contractForm.value;
    data['id'] = this.record['id'];
    try{
      this.customMessageService.open({title: 'Espere', type: 'success', message: 'Guardando información...', loading: true });
      data['operationType'] = 'single'
      let apiResponse = await this.contractsService.update(data);
      //log.debug(apiResponse)
      this.customMessageService.close()
      if (apiResponse['state'] == 'success') {
        await this.customMessageService.open({title: '¡Hecho!', type: apiResponse['state'], message: apiResponse['message'], duration: 2000 });
        let row = apiResponse['data'][0];
        this.dialogRef.close(row);
      }else{
        await this.customMessageService.open({title: 'Error', type: apiResponse['state'], message: apiResponse['message'], dismissBtn: true });
      }
    }catch(err){
      this.customMessageService.close();
      await this.customMessageService.open({title: 'Error', type: 'error', message: err, dismissBtn: true });
    }
  }

}
